import { BaseApiClient } from '@/services/baseApiClient';
import type { RequestOptions } from '@/utils/request';
import type { Args, Results } from '.';

export interface IUserFavouritesApiClient {
  create(args: Args.CreateFavouriteArgs): Promise<Results.CreateFavouriteResult>;
  getAll(args: Args.GetFavouritesArgs, signal: RequestOptions['signal']): Promise<Results.GetFavouritesResult>;
  update(args: Args.UpdateFavouriteArgs): Promise<Results.UpdateFavouriteResult>;
  delete(args: Args.DeleteFavouriteArgs): Promise<Results.DeleteFavouriteResult>;
}

export class UserFavouritesApiClient extends BaseApiClient implements IUserFavouritesApiClient {
  constructor() {
    super('api/users');
  }

  public create({ userId, payload }: Args.CreateFavouriteArgs): Promise<Results.CreateFavouriteResult> {
    return this.http.post(`${userId}/favourites`, payload);
  }

  public getAll(
    { userId }: Args.GetFavouritesArgs,
    signal: RequestOptions['signal'],
  ): Promise<Results.GetFavouritesResult> {
    return this.http.get(`${userId}/favourites`, { signal });
  }

  public update({ userId, favouriteId, payload }: Args.UpdateFavouriteArgs): Promise<Results.UpdateFavouriteResult> {
    return this.http.patch(`${userId}/favourites/${favouriteId}`, payload);
  }

  public delete({ userId, favouriteId }: Args.DeleteFavouriteArgs): Promise<Results.DeleteFavouriteResult> {
    return this.http.delete(`${userId}/favourites/${favouriteId}`);
  }
}
